import { render } from "./TernButtonQuiz.vue?vue&type=template&id=53ff7900&scoped=true"
import script from "./TernButtonQuiz.vue?vue&type=script&lang=js"
export * from "./TernButtonQuiz.vue?vue&type=script&lang=js"

import "./TernButtonQuiz.vue?vue&type=style&index=0&id=53ff7900&scoped=true&lang=css"

import exportComponent from "/Users/tavishi/Desktop/Tilly/code/tern-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53ff7900"]])

export default __exports__